import { useSession } from "../contexts/SessionContext"
import { apiFetch } from "@prescreen/lib/api-client"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"

export default function UserInfo() {
  const { user, loading } = useSession()

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-600">
        Loading...
      </div>
    )
  }

  if (!user) {
    return null
  }

  const handleSignOut = async () => {
    try {
      await apiFetch('/api/auth/signout', { method: 'POST' })
      window.location.href = '/login'
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  const roleColors: Record<string, string> = {
    administrator: "bg-purple-100 text-purple-800 border-purple-200",
    integrator: "bg-blue-100 text-blue-800 border-blue-200",
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex flex-col items-end">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-900">
            {user.email}
          </span>
          <Badge
            className={`text-xs font-semibold border ${roleColors[user.role] || "bg-gray-100 text-gray-800 border-gray-200"}`}
          >
            {user.role}
          </Badge>
        </div>
        {user.emailVerified && (
          <span className="text-xs text-green-600">Verified</span>
        )}
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleSignOut}
      >
        Sign Out
      </Button>
    </div>
  )
}
